module.exports = __webpack_public_path__ + "c1642a755bc1b8bfbcc2f95d52c3496b.png";